// 一日一分の提案と、一分間のタイマー（詳細ページ用）
import React from 'react';

export default function OneMinute({ text }: { text: string }) {
  const [left, setLeft] = React.useState<number | null>(null); // null=未開始, 0=終了
  React.useEffect(() => {
    if (left == null || left <= 0) return;
    const id = setTimeout(() => setLeft((v) => (v == null ? v : v - 1)), 1000);
    return () => clearTimeout(id);
  }, [left]);

  const running = left != null && left > 0;
  const done = left === 0;
  const pct = left == null ? 0 : ((60 - left) / 60) * 100;

  return (
    <div style={{ background: 'rgba(232,201,106,0.08)', border: '1px solid #C9A84C88', borderRadius: '12px', padding: '14px' }}>
      <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#e8c96a', marginBottom: '6px', fontFamily: "'Shippori Mincho', serif", letterSpacing: '1px' }}>
        🧘 一日一分の習慣
      </div>
      <div style={{ fontSize: '15px', lineHeight: 1.9, fontFamily: "'Noto Serif JP', serif" }}>{text}</div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '12px' }}>
        <button
          type="button"
          onClick={() => setLeft(running ? null : 60)}
          style={{ padding: '8px 16px', borderRadius: '999px', border: '1px solid #e8c96a', background: running ? 'transparent' : '#e8c96a', color: running ? '#e8c96a' : '#0f172a', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          {running ? 'やめる' : done ? 'もう一度' : '一分はじめる'}
        </button>
        <div style={{ flex: 1 }}>
          {running && (
            <>
              <div style={{ height: '4px', background: '#334155', borderRadius: '2px', overflow: 'hidden' }}>
                <div style={{ width: `${pct}%`, height: '100%', background: '#e8c96a', transition: 'width 1s linear' }} />
              </div>
              <div style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '4px' }} aria-live="polite">あと {left} 秒</div>
            </>
          )}
          {done && <div style={{ fontSize: '13px', color: '#e8c96a' }} aria-live="polite">おつかれさまでした。今日もいい一日を。</div>}
        </div>
      </div>
      <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '8px' }}>無理のない姿勢で、心地よい範囲で行ってください。</div>
    </div>
  );
}
